import { memo } from "react";
import { useLocation } from "react-router-dom";
import { isLiffRoutePath } from "../../../utils/liffRoute";
import { ENABLE_FLOATING_RECORDER } from "./constants";
import { useRecorderStable } from "./RecorderContext";
import RecorderSection from "./RecorderSection";
import useFloatingPanel from "./useFloatingPanel";

const FloatingRecorderContent = memo(function FloatingRecorderContent() {
    return <RecorderSection variant="floating" />;
});

export default function FloatingRecorder() {
    if (!ENABLE_FLOATING_RECORDER) {
        return null;
    }

    const location = useLocation();
    const {
        dockedRect,
        isRecorderVisible,
    } = useRecorderStable();
    const isVisitingManagementRoute = location.pathname.startsWith("/visiting-management");
    const shouldShowFloatingRecorder = isRecorderVisible
        && !isVisitingManagementRoute
        && !isLiffRoutePath(location.pathname);

    const {
        handlePointerDown,
        handlePointerMove,
        handlePointerUp,
        isRendered,
        isVisible,
        panelRef,
        style,
    } = useFloatingPanel({
        dockedRect,
        isDockedRoute: isVisitingManagementRoute,
        isOpen: shouldShowFloatingRecorder,
    });

    if (!isRendered) {
        return null;
    }

    return (
        <div
            ref={panelRef}
            className={`fixed z-[120] w-[340px] max-w-[100vw] touch-none ${isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
                }`}
            style={style}
            onPointerDown={handlePointerDown}
            onPointerMove={handlePointerMove}
            onPointerUp={handlePointerUp}
            onPointerCancel={handlePointerUp}
        >
            <div className="cursor-grab active:cursor-grabbing">
                <FloatingRecorderContent />
            </div>
        </div>
    );
}
